<template>
    <div class="card">
        <div class="row">
            <Toast />
            <DataTable :value="all_cruise_lines" :paginator="true" :rows="10"
            :paginatorTemplate="paginatorTemplate"
            :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll" scrollable 
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            stripedRows :loading="loading" removableSort
            :globalFilterFields="['name']"
            v-model:filters="filters">   
                <template #header>
                    <div class="row">
                        <div class="table-header flex flex-column md:flex-row md:justify-content-end">
                            <span class="p-input-icon-left ">
                                <i class="pi pi-search" />
                                <InputText id="filter_cruise_lines" v-model="filters['global'].value" placeholder="Keyword Search" class="input_small"/>
                            </span>
                        </div>
                    </div>
                </template>
                <Column header="Name" field="name" :sortable="true"> 
                </Column>
                <Column header="Group" field="id_cruise_group.name" :sortable="true">
                </Column>
                <Column v-if="$can('change','cruise_line')" header="Edit" style="width: 7rem;" bodyStyle="overflow: visible">
                    <template #body="slotProps">
                        <Button data-cy="edit_button" icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-outlined" @click="edit_cruise_line(slotProps.data)"/>
                    </template>
                </Column>
                <Column v-if="$can('delete','cruise_line')" header="Delete" style="width: 7rem;" bodyStyle="overflow: visible">
                    <template #body="slotProps">
                        <Button data-cy="delete_button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-outlined" @click="confirm_delete_cruise_line(slotProps)"/>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog data-cy="edit_cruise_line_modal" v-model:visible="cruise_line_dialog" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}" header="Cruise Line Details" :modal="true" class="p-fluid">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="name" class="pb-1 ps-1"> <strong> Name </strong> </label>
                        <InputText id="name" v-model.trim="cruise_line.name" required="true" autofocus :class="{'p-invalid': submitted && !cruise_line.name || cruise_line_errors.name}" />
                        <small class="p-error" v-if="submitted && !cruise_line.name">Name is required.</small>
                        <small v-if="Object.keys(cruise_line_errors).length !== 0 && cruise_line_errors.name" class="p-error"><span v-for="error in cruise_line_errors.name" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="groups" :class="{'p-invalid': submitted && !cruise_line.id_groups || cruise_line_errors.id_groups}" class="pb-1 ps-1"> <strong> Groups </strong> </label>  
                        <Dropdown id="id_groups" v-model="cruise_line.id_cruise_group" :options="all_groups" optionLabel="name" :filter="true"> 
                        <template #value="slotProps">
                            <div v-if="slotProps.value && slotProps.value.name">
                                <span>{{slotProps.value.name}}</span>
                            </div>
                            <div v-else-if="slotProps.label && !slotProps.value.value">
                                <span >{{slotProps.name}}</span>
                            </div>
                        </template>
                        </Dropdown>
                    </div>
                    <small v-if="Object.keys(cruise_line_errors).length !== 0 && cruise_line_errors.id_groups" class="p-error"><span v-for="error in cruise_line_errors.id_groups" :key="error">{{error}}<br></span></small>                      
                </div>
            </div>
        </div>
        
        <template #footer>
            <Button label="Cancel" class="p-button-text" @click="hide_cruise_line_dialog"/>
            <Button data-cy="save_edit_cruise_line" label="Save" @click="save_cruise_line" />
        </template>
    </Dialog>

    <Dialog v-model:visible="delete_cruise_line_dialog" :style="{width: '450px'}" header="Confirm" :modal="true">
        <div class="confirmation-content">
            <span v-if="cruise_line">Are you sure you want to delete <b>{{cruise_line.data.name}}</b>?</span>
        </div>
        <template #footer>
            <Button label="No" class="p-button-text" @click="delete_cruise_line_dialog = false"/>
            <Button data-cy="confirm_delete_button" label="Yes"  @click="deleteCruise_lines" />
        </template>
    </Dialog>

</template>

<script> 
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext';
import Toast from 'primevue/toast';
import Dropdown from 'primevue/dropdown'
import { FilterMatchMode } from 'primevue/api';
import { useVuelidate } from "@vuelidate/core"
import { required } from '@vuelidate/validators'

export default {
    setup: () => ({ v$: useVuelidate() }),
    name: 'TableCruise_lines',
    components: {
        DataTable,
        Column,
        Button,
        Dialog,
        InputText,
        Toast,
        Dropdown
    },
    data() {
        return {
            id: '',
            cruise_line: {},
            cruise_line_errors:{},
            cruise_line_dialog: false,
            delete_cruise_line_dialog: false,
            submitted: false,
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            },
            loading: false,
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        }
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        if(this.all_cruise_lines.length == 0) {
            this.loading = true
            await this.$store.dispatch('load_all_cruise_lines')
            await this.$store.dispatch('load_all_groups')
            this.loading = false
        }
    },

    async unmounted(){
        window.removeEventListener('resize', this.handleResize);
    },

    computed: {
        all_cruise_lines: function() {
            return this.$store.getters.all_cruise_lines
        },
        get_errors_cruise_line: function() {
            return this.$store.getters.get_errors_cruise_line
        },
        get_delete_cruise_line_status: function() {
            return this.$store.getters.get_delete_cruise_line_status
        },
        all_groups: function() {
            return this.$store.getters.all_groups
        },
    },
    methods: {

        async handleResize(){
            if (window.innerWidth <= 767){
                this.paginatorTemplate = "CurrentPageReport PrevPageLink NextPageLink"
            } else {
                this.paginatorTemplate = "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            }
        },

        confirm_delete_cruise_line(cruise_line) {
            this.cruise_line = cruise_line;
            this.delete_cruise_line_dialog = true;
        },
        async deleteCruise_lines() {
            await this.$store.dispatch('delete_cruise_line', this.cruise_line.data.id)
            if (this.get_delete_cruise_line_status === false){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Cruise line deleted', life: 3000});
            } else {
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'error', summary: 'Error', detail: "Cruise line can't be deleted", life: 3000});
            }
            this.delete_cruise_line_dialog = false;
        },
        edit_cruise_line(cruise_line) {
            this.cruise_line = {...cruise_line};
            this.cruise_line_dialog = true;
        },
        async save_cruise_line() {
            this.submitted = true;
			if (this.cruise_line.name.trim()) {
                await this.$store.dispatch('update_cruise_line', this.cruise_line)
                this.cruise_line_errors = this.get_errors_cruise_line
                
                if(Object.keys(this.cruise_line_errors).length === 0){
                    this.cruise_line_dialog = false;
                    this.cruise_line = {};
                    this.$toast.removeAllGroups();
                    this.$toast.add({severity:'success', summary: 'Successful', detail: 'Cruise line modified', life: 3000});
                }
                
            }
        },
        hide_cruise_line_dialog() {
            this.cruise_line_dialog = false;
            this.submitted = false;
        },
    },
    validations() {
        return {
            name: { required },
            id_groups: { required }
        }
    },

}
</script>

<style  scoped>
.card {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
    border-radius: 10px;
    margin-bottom: 1rem;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

:deep(.p-inputtext){
    font-size: 1rem;
    margin: auto;
}

.input_small{
    font-size: .8rem !important; 
}

</style>